// SPDX-License-Identifier: AGPL-3.0-or-later
// SPDX-FileCopyrightText: 2026 Ben Richardson <hi@ben.gy>

import type { ClimateData } from '../types';
import { buildInsights } from '../analysis';
import { esc } from '../format';
import { sectionHead } from './ui';

const ICON: Record<string, string> = { alert: '▲', warn: '●', info: 'ℹ' };

export function mount(el: HTMLElement, data: ClimateData): void {
  const insights = buildInsights(data);
  el.innerHTML = `
    <section class="panel">
      ${sectionHead('What the record shows', 'Findings detected automatically from the ACORN-SAT record. Each is derived from the data on this site.')}
      <div class="insight-grid">
        ${insights.map((ins) => `
          <article class="insight ${ins.severity}">
            <div class="insight-badge" aria-hidden="true">${ICON[ins.severity]}</div>
            <div class="insight-body">
              <h3>${esc(ins.title)}</h3>
              <p>${esc(ins.body)}</p>
            </div>
          </article>`).join('')}
      </div>
    </section>`;
}
